module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "text-align": "center",
      "height": "80px",
      "line-height": "80px"
    }
  }, [_vm._v("\n\t商城固定头部\n")])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-0d3e7ae0", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0d3e7ae0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/pc/homePage/components/common/Header.vue
// module id = 2460
// module chunks = 0